export { KeyboardShortcut, prettifyShortcut } from '@gitbook/spine-react';
